import React from "react";
import { useTheme } from "@mui/material/styles";

import LogoGlosari from "../assets/background/logo/logoGlosari.png";

export default function LayoutHeader({ title }) {
  const theme = useTheme();

  return (
    <div className="flex items-center gap-4 pt-5 pb-5 pl-10">
      <img
        src={LogoGlosari}
        style={{ width: "100px", height: "auto", objectFit: "contain" }}
      />
      <h1
        style={{ color: theme.palette.primary.main }}
        className="font-inter font-semibold !text-[24px]"
      >
        {title}
      </h1>
    </div>
  );
}
